import involved1 from "../../../assets/images/involved-1.png";
import involved2 from "../../../assets/images/involved-2.png";
import involved3 from "../../../assets/images/involved-3.png";
import involved4 from "../../../assets/images/involved-4.png";
import "./Involved.scss";
const Involved = () => {
  return (
    <section>
      <div className="involved">
        <div className="container">
          <div className="title">
            4 ways to get <span>involved</span>
          </div>
          <div className="custom-col">
            <div className="custom-row">
              <div className="involved-img-div">
                <img src={involved1} alt="involved" />
              </div>
              <div className="involved-desc">
                Support feasibility studies for critical projects
              </div>
            </div>
            <div className="custom-row">
              <div className="involved-img-div">
                <img src={involved2} alt="involved" />
              </div>
              <div className="involved-desc">
                Express interest as a technical partner for implementation
              </div>
            </div>
            <div className="custom-row">
              <div className="involved-img-div">
                <img src={involved3} alt="involved" />
              </div>
              <div className="involved-desc">
                Join a Public-Private Partnership to co-develop solutions
              </div>
            </div>
            <div className="custom-row">
              <div className="involved-img-div">
                <img src={involved4} alt="involved" />
              </div>
              <div className="involved-desc">
                Invest in bankable or blended finance portfolios
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Involved;
